export default function Arrow({className, onClick}) {
  return <svg className={className} onClick={onClick} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="12" fill="#F4C842"/>
    <path d="M15 7L9.13923 11.1863C8.58088 11.5851 8.58088 12.4149 9.13923 12.8137L15 17" stroke="black"/>
  </svg>

}